export const environment = {
    NODE_ENV: 'dev',
    USER_POOL_CLIENT_ID: '2iqisrl45netbepu0ih3paea4r',
    USER_POOL_ID: 'us-east-1_yftnVQ7Q0',
    IDENTITY_POOL_ID: 'us-east-1:34557cbd-db41-436f-b54d-b3266344c926',
    OAUTH_DOMAIN: 'watter-dev.auth.us-east-1.amazoncognito.com',
    API_END_POINT: 'https://dev.api.wattertechnologies.com/graphql',
    S3_BUCKET: '296062565941-account-profile-dev',
    APP_REGION: 'us-east-1',
    APP_VERSION: '1.0.6',
};
